import { useQuery } from '@tanstack/react-query';
import userRepository from '@/api/repositories/userRepository/UserRepository.ts';

export const useUsers = () => {
  return useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const { data, error } = await userRepository.all({ order: { by: 'created_at', ascending: false } });
      if (error) throw new Error(error.message);
      return data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};
